module.exports = __webpack_public_path__ + "static/media/location-icon-bassa-severity-2.63ad021a.png";